export class SiteCost {
  name: string;
  siteCostId: number;
  currency: string;
  unitPrice: number;
  costId: number;
}